import React, { useState, useContext } from 'react';
import { UserContext, WorkspaceContext } from '../../objects/Context';
import { ReactComponent as CopyIcon } from '../../assets/icons/copy-icon.svg';
import { ReactComponent as LikeIcon } from '../../assets/icons/thumb-up-icon.svg';
import { ReactComponent as DislikeIcon } from '../../assets/icons/thumb-down-icon.svg';
import { ReactComponent as DownloadIcon } from '../../assets/icons/download-icon.svg';
import axios from 'axios';
import './MessageActions.css';
import Popup from '../Popup/Popup';

const MessageActions = ({message}) => {
    const { user } = useContext(UserContext);
    const { workspace } = useContext(WorkspaceContext);
    const [liked, setLiked] = useState(false);
    const [disliked, setDisliked] = useState(false);
    const [tooltipTexts, setTooltipTexts] = useState({
        like: "Like this message",
        dislike: "Dislike this message",
        copy: "Copy to clipboard",
        download: "Download data"
    });

    // Check if message was created within the last hour
    const isWithinOneHour = () => {
        const messageTime = new Date(message.timestamp);
        const currentTime = new Date();
        const oneHourAgo = new Date(currentTime.getTime() - (60 * 60 * 1000));
        return messageTime >= oneHourAgo;
    };

    const copyToClipboard = (content) => {
        navigator.clipboard.writeText(content);
        setTooltipTexts(prev => ({...prev, copy: "Copied!"}));
        setTimeout(() => {
            setTooltipTexts(prev => ({...prev, copy: "Copy to clipboard"}));
        }, 2000);
    }

    const likeMessage = (id) => {
        if (liked) return;
        setLiked(true);
        setDisliked(false);
        setTooltipTexts(prev => ({...prev, dislike: "Dislike this message"}));
        setTooltipTexts(prev => ({...prev, like: "Liked!"}));

        axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/feedback/save-feedback`, {
            parentId: id,
            parentType: 'message',
            isPositive: true,
            userId: user.id,
            workspaceId: workspace.id,
            createdAt: new Date().toISOString()
        }, { withCredentials: true })
            .then(response => {
                // setTimeout(() => {
                //     setTooltipTexts(prev => ({...prev, like: "Like this message"}));
                // }, 2000);
            })
            .catch(error => {
                console.error('Error updating like status:', error);
            });
    }

    const dislikeMessage = (id) => {
        if (disliked) return;
        setDisliked(true);
        setLiked(false);
        setTooltipTexts(prev => ({...prev, like: "Like this message"}));
        setTooltipTexts(prev => ({...prev, dislike: "Disliked!"}));

        axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/feedback/save-feedback`, {
            parentId: id,
            parentType: 'message',
            isPositive: false,
            userId: user.id,
            workspaceId: workspace.id,
            createdAt: new Date().toISOString()
        }, { withCredentials: true })
            .then(response => {
                // Optionally reset tooltip after a delay
            })
            .catch(error => {
                console.error('Error updating dislike status:', error);
            });
    }

    const downloadMessage = async (messageId) => {
        setTooltipTexts(prev => ({...prev, download: "Downloading..."}));
        try {
            // Prefer reference-based download if available
            const refs = Array.isArray(message.references) ? message.references : [];
            const ref = refs[0] || messageId; // fallback to legacy route param
            const response = await axios.get(
                `${process.env.REACT_APP_API_BASE_URL}/api/threads/download-data/${ref}`,
                {
                    responseType: 'blob',
                    withCredentials: true
                }
            );

            // Create a URL for the blob and trigger download as XLSX
            const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `vairo-data.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

            setTooltipTexts(prev => ({...prev, download: "Downloaded!"}));
        } catch (error) {
            setTooltipTexts(prev => ({...prev, download: "Download failed"}));
            console.error('Error downloading message data:', error);
        } finally {
            setTimeout(() => {
                setTooltipTexts(prev => ({...prev, download: "Download data"}));
            }, 2000);
        }
    }

    return (
      <div className="message-actions">
        <div className="icon-container">
          <LikeIcon className={`icon like ${liked ? 'active' : ''}`} onClick={() => likeMessage(message.id)} />
          <span className="tooltip">{tooltipTexts.like}</span>
        </div>
        <div className="icon-container">
          <DislikeIcon className={`icon dislike ${disliked ? 'active' : ''}`} onClick={() => dislikeMessage(message.id)} />
          <span className="tooltip">{tooltipTexts.dislike}</span>
        </div>
        <div className="icon-container">
          <CopyIcon className="icon copy" onClick={() => copyToClipboard(message.content)} />
          <span className="tooltip">{tooltipTexts.copy}</span>
        </div>
        {message.references && message.references.length > 0 && isWithinOneHour() && (
          <div className="icon-container">
            <DownloadIcon className="icon download" onClick={() => downloadMessage(message.id)} />
            <span className="tooltip">{tooltipTexts.download}</span>
          </div>
        )}
      </div>
    );
  }

  export default MessageActions;